export default "__VITE_PUBLIC_ASSET__463bd177__"